import { PageContainer } from '../components/PageContainer';
import { Button } from '../components/ui/Button';

export const ButtonTest = () => {
  const handleClick = (buttonType: string) => {
    // eslint-disable-next-line no-console
    console.log(`${buttonType} clicked`);
  };

  return (
    <PageContainer variant="white" className="space-y-8">
      <div>
        <h1 className="text-4xl font-bold">Button Test Page</h1>
        <p className="text-gray-600 mt-2">Testing all button variants</p>
      </div>
      
      <section className="space-y-4">
        <h2 className="text-2xl font-semibold">Design System Buttons</h2>
        
        <div className="space-y-4">
          <div>
            <h3 className="text-lg font-medium mb-2">Primary Variant</h3>
            <Button variant="primary" onClick={() => handleClick('Primary')}>
              Primary Button
            </Button>
          </div>
          
          <div>
            <h3 className="text-lg font-medium mb-2">Secondary Variant</h3>
            <Button variant="secondary" onClick={() => handleClick('Secondary')}>
              Secondary Button
            </Button>
          </div>
          
          <div>
            <h3 className="text-lg font-medium mb-2">Outline Variant</h3>
            <Button variant="outline" onClick={() => handleClick('Outline')}>
              Outline Button
            </Button>
          </div>
          
          <div>
            <h3 className="text-lg font-medium mb-2">Ghost Variant</h3>
            <Button variant="ghost" onClick={() => handleClick('Ghost')}>
              Ghost Button
            </Button>
          </div>
          
          <div>
            <h3 className="text-lg font-medium mb-2">Link Variant</h3>
            <Button variant="link" onClick={() => handleClick('Link')}>
              Link Button
            </Button>
          </div>
          
          <div>
            <h3 className="text-lg font-medium mb-2">Loading State</h3>
            <Button variant="primary" loading onClick={() => handleClick('Loading')}>
              Loading Button
            </Button>
          </div>
          
          <div>
            <h3 className="text-lg font-medium mb-2">Disabled State</h3>
            <Button variant="primary" disabled onClick={() => handleClick('Disabled')}>
              Disabled Button
            </Button>
          </div>
        </div>
      </section>
      
      <section className="space-y-4">
        <h2 className="text-2xl font-semibold">Comparison with Regular Button</h2>
        
        <div className="flex gap-4 items-center">
          <button
            onClick={() => handleClick('Regular button')}
            className="px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors"
          >
            Regular Button
          </button>
          
          <Button variant="primary" onClick={() => handleClick('Design system')}>
            Design System Button
          </Button>
        </div>
      </section>
      
      <section className="space-y-4">
        <h2 className="text-2xl font-semibold">Debug Info</h2>
        <div className="bg-gray-100 p-4 rounded-lg">
          <p>If you see this text but no design system buttons above, there's an issue with the Button component.</p>
          <p>Check the browser console for any JavaScript errors.</p>
        </div>
      </section>
    </PageContainer>
  );
};